/**
 * @file Defines the {@link VERSION} constant
 * @author Joe Thompson <joe.thompson@1x2gaming.com>
 */

/** @namespace window */

/**
 * Current framework version number
 * @type {string}
 * @constant
 * @default
 * @memberof window
 */
const VERSION = '1.1.7'

//Expose via window
window['infrastr_ids_ui'] = `v${VERSION}`

export { VERSION }